import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RequestHelp() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Request God to help you." />
        <blockquote>
          “For my eyes are toward Thee, O God, the Lord; In Thee I take refuge; do not leave me defenseless. Keep me from the jaws of the trap which they have set for me, And from the snares of those who do iniquity.” (Psalm 141:8-9)
        </blockquote>

        <p>It is impossible to overcome temptation by our own strength. We must have at our disposal God’s power, wisdom, and help to overcome temptation. As discussed in the “Rebuild” section, we must abide in Christ and be filled with His Spirit. He will come to our aid if we truly want victory over sin. But often, we forget to simply ask for God’s help. God will give us additional strength, a critical push, an open door, a bit of insight, more determination, a renewed sense of purpose, and whatever is needed in times of need if we ask Him. When temptation seems too much to bear, get in the habit of praying and crying out to God for help. Do not lean solely on your own understanding and strength (Proverbs 3:5-6). Pray to God and ask His help when temptation comes.</p>
        <br />

        <ul>
          <li>
            <strong>Cry out to the Lord for deliverance from sin and temptation.</strong><br />
            <em>Psalm 18:6, 28:1-3, 31:1-5, 34:4-7, 15-18, 39:8, 57:1-6, 61:1-4, 69:13-19, 77:1-6, 116:1-11, 119:58, 94, 173, 176, 141:1-4, 8-10, 143:9-12, Matthew 6:13</em>
          </li>
          <br />
          <li>
            <strong>Ask God to show you the way of escape that you may be able to endure it.</strong><br />
            <em>Psalm 116:8, Proverbs 18:10, 1 Corinthians 10:13</em>
          </li>
          <br />
          <li>
            <strong>Confess your sins and desire for sin to God.</strong><br />
            <em>1 John 1:7-10</em>
          </li>
          <br />
          <li>
            <strong>Ask God to give you wisdom, make obvious the right way from the wrong, His will versus sin.</strong><br />
            <em>Psalm 119:33-39, James 1:5-8</em>
          </li>
          <br />
          <li>
            <strong>Take concerns and anxieties immediately to God.</strong><br />
            <em>Philippians 4:6-7</em>
          </li>
          <br />
          <li>
            <strong>Know you have a sympathetic and victorious High Priest who comes to the aid of those who are tempted.</strong><br />
            <em>Hebrews 2:17-18, 4:14-16, 7:23-28, 1 John 2:1-2</em>
          </li>
          <br />
          <li>
            <strong>Pray for the spiritual and eternal benefit of those who are the source of your temptation.</strong><br />
            <em>Retaliate in prayer and pray for the destruction of Satan’s strongholds. Choose a prayer request that would do significant harm to Satan’s agenda and pray for it when temptation comes. Matthew 5:44, Luke 23:34, 2 Corinthians 10:4</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
